import React from 'react';

import {
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
  Grid,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { AmountFormatter } from '@gogame/intl-ts';

import IODetails from 'scenes/IO/components/IODetails/IODetails';
import IOTitle from 'scenes/IO/components/IOTitle';
import Status from 'scenes/IO/components/Status';

const IOS = ({ data = [] }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleOpenIO = (id) => {
    openChildComponent(IODetails, {
      id: id,
    });
  };

  return (
    <React.Fragment>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell align={'right'}>Monthly budget</TableCell>
              <TableCell width={75}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((io, i) => {
              return (
                <TableRow key={i}>
                  <TableCell>
                    <Typography>{io.id}</Typography>
                  </TableCell>
                  <TableCell>
                    <Link onClick={() => handleOpenIO(io.id)}>
                      <IOTitle
                        businessPartner={io.businessPartner}
                        period={io.period}
                      />
                    </Link>
                  </TableCell>
                  <TableCell align={'right'}>
                    <Typography>
                      <AmountFormatter {...io.budget} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Grid container>
                      <Status id={io.status.id}>{io.status.name}</Status>
                    </Grid>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {childComponent}
    </React.Fragment>
  );
};

export default IOS;
